import {TreatmentHoldInitiator, TreatmentHoldInitiatorMap} from "providerapp/client/domain";
import {EnumToMapping} from "common";

export enum ClinicalRecommendationChangeOption {
    Service_Type = "Service Type",
    Location = "Location",
    Recommended_Hours = "Recommended Hours"
}

export const {nameToValue: ClinicalRecommendationChangeOptionMap} = EnumToMapping(ClinicalRecommendationChangeOption);

export enum ClientServicesReceivedOption {
    YES_ASSESSMENT = "Yes, Assessment",
    YES_TREATMENT = "Yes, Treatment",
    NO = "No",
    TRANSFER_REEVALUATION = "Yes, Transfer Re-evaluation"
}

export const {
    nameToValue: ClientServicesReceivedOptionMap
} = EnumToMapping(ClientServicesReceivedOption);

export enum CanContinueOption {
    YES = "YES",
    NO = "NO"
}

export const CanContinueOptionMap = new Map<string, string>([
    [CanContinueOption.YES, "Yes"],
    [CanContinueOption.NO, "No"]
]);

export enum ServiceLocationOption {
    ClinicCenter = "ClinicCenter",
    Home = "Home",
    Telehealth = "Telehealth",
    Community = "Community"
}

export const ServiceLocationOptionMap = new Map<string, string>([
    [ServiceLocationOption.ClinicCenter, "Clinic/Center"],
    [ServiceLocationOption.Home, "Home"],
    [ServiceLocationOption.Telehealth, "Telehealth"],
    [ServiceLocationOption.Community, "Community"]
]);

enum ClientReturnTransferRequestReasons {
    NOT_OFFERED_FULL_HOURS = "Not being offered full clinically recommended hours",
    GRIEVANCE_WITH_PROVIDER = "Grievance or Reportable Event with provider",
    CONCERNS_WITH_QUALITY = "Service quality concerns",
    PREFERS_PROVIDER_CLOSER = "Prefers provider closer to home",
    DISAGREES_WITH_TREATMENT = "Disagrees with treatment recommendations",
    CLIENT_MOVED = "Client moved",
    CLIENT_FAMILY_SCHEDULE_CHANGED = "Client/Family schedule changed",
    PREFERS_IN_PERSON_TREATMENT = "Prefers in-person treatment",
    CLIENT_SCHEDULE_CHANGE = "Client’s schedule change",
    HIGH_FREQUENCY_ATTENDANCE_CONCERNS = "High frequency of attendance concerns",
    CLIENT_FAMILY_DECLINING_TREATMENT = "Client/Family declining treatment offers",
    PROVIDER_RECOMMENDING_UNOFFERED_SERVICES = "Service Not offered by Provider",
    INAPPROPRIATE_CAREGIVER_BEHAVIOR = "Inappropriate caregiver behavior",
    PROVIDER_INABILITY_TO_STAFF = "Provider’s inability to staff",
    REQUESTING_IN_PERSON_UNABLE_TO_STAFF = "Client/Caregiver requesting in-person services, current provider unable to staff",
    CLIENT_OUT_OF_SERVICE_AREA = "Client is no longer in provider’s contracted service area",
    ADMINISTRATIVE_ERROR = "Administrative Error",
    ADMINISTRATIVE_REQUEST = "Administrative Request"
}

enum ClientFamilyRequestReasons {
    NOT_OFFERED_FULL_HOURS = ClientReturnTransferRequestReasons.NOT_OFFERED_FULL_HOURS,
    GRIEVANCE_WITH_PROVIDER = ClientReturnTransferRequestReasons.GRIEVANCE_WITH_PROVIDER,
    CONCERNS_WITH_QUALITY = ClientReturnTransferRequestReasons.CONCERNS_WITH_QUALITY,
    PREFERS_PROVIDER_CLOSER = ClientReturnTransferRequestReasons.PREFERS_PROVIDER_CLOSER,
    DISAGREES_WITH_TREATMENT = ClientReturnTransferRequestReasons.DISAGREES_WITH_TREATMENT,
    CLIENT_MOVED = ClientReturnTransferRequestReasons.CLIENT_MOVED,
    CLIENT_FAMILY_SCHEDULE_CHANGED = ClientReturnTransferRequestReasons.CLIENT_FAMILY_SCHEDULE_CHANGED,
    PREFERS_IN_PERSON_TREATMENT = ClientReturnTransferRequestReasons.PREFERS_IN_PERSON_TREATMENT
}

const {nameToValue: ClientFamilyRequestReasonsMap} = EnumToMapping(ClientFamilyRequestReasons);

enum ProviderRequestReasons {
    CLIENT_SCHEDULE_CHANGE = ClientReturnTransferRequestReasons.CLIENT_SCHEDULE_CHANGE,
    HIGH_FREQUENCY_ATTENDANCE_CONCERNS = ClientReturnTransferRequestReasons.HIGH_FREQUENCY_ATTENDANCE_CONCERNS,
    CLIENT_FAMILY_DECLINING_TREATMENT = ClientReturnTransferRequestReasons.CLIENT_FAMILY_DECLINING_TREATMENT,
    PROVIDER_RECOMMENDING_UNOFFERED_SERVICES = ClientReturnTransferRequestReasons.PROVIDER_RECOMMENDING_UNOFFERED_SERVICES,
    INAPPROPRIATE_CAREGIVER_BEHAVIOR = ClientReturnTransferRequestReasons.INAPPROPRIATE_CAREGIVER_BEHAVIOR,
    PROVIDER_INABILITY_TO_STAFF = ClientReturnTransferRequestReasons.PROVIDER_INABILITY_TO_STAFF,
    REQUESTING_IN_PERSON_UNABLE_TO_STAFF = ClientReturnTransferRequestReasons.REQUESTING_IN_PERSON_UNABLE_TO_STAFF
}

const {nameToValue: ProviderRequestReasonsMap} = EnumToMapping(ProviderRequestReasons);

enum CareServiceReason {
    ADMINISTRATIVE_ERROR = ClientReturnTransferRequestReasons.ADMINISTRATIVE_ERROR,
    ADMINISTRATIVE_REQUEST = ClientReturnTransferRequestReasons.ADMINISTRATIVE_REQUEST
}

const {nameToValue: CareServiceReasonMap} = EnumToMapping(CareServiceReason);

export const requestReasonOptionsByRequestInitiator = (requestMadeBy: string) => {
    switch (TreatmentHoldInitiatorMap.get(requestMadeBy)) {
        case TreatmentHoldInitiator.Client_Family:
            return ClientFamilyRequestReasonsMap;
        case TreatmentHoldInitiator.Provider:
            return ProviderRequestReasonsMap;
        case TreatmentHoldInitiator.Catalight_Care_Services:
            return CareServiceReasonMap;
    }

    return new Map<string, string>();
}

